// src/components/VisionMission/VisionMission.js
import styles from "./VisionMission.module.css"

const VisionMission = () => {
  return (
   <section className={styles.vision} id="vision"> 
    <div className={styles.visionMission}>
      <div className={styles.gradientBar}>
        <div className={styles.iconContainer}>
          <div className={styles.iconWrapper}>
            <img className={styles.icon} alt="Mission icon" src="/images/mission-icon.svg" />
          </div>
          <div className={styles.iconWrapper}>
            <img className={styles.icon} alt="Vision icon" src="/images/vision-icon.svg" />
          </div>
          <div className={styles.iconWrapper}>
            <img className={styles.icon} alt="Values icon" src="/images/values-icon.svg" />
          </div>
        </div>
      </div>

      <section className={styles.contentSection}>
        <div className={styles.column}>
          <h2 className={styles.heading}>MISSION</h2>
          <p className={styles.text}>
            At Teezash, we are committed to revolutionizing safety with smart IoT solutions that make homes and
            communities smarter, safer, and more connected. Our mission is to empower individuals and families with
            technology that seamlessly integrates into their lives, ensuring peace of mind and convenience.
          </p>
        </div>

        <div className={styles.column}>
          <h2 className={styles.heading}>VISION</h2>
          <p className={styles.text}>
            Our vision is to lead the way in IoT-driven safety, creating innovative solutions that transform everyday
            living into a safer, smarter, and more sustainable experience. We aspire to be a global leader in fostering
            smarter living spaces, redefining how safety and technology come together.
          </p>
        </div>

        <div className={styles.column}>
          <h2 className={styles.heading}>VALUES</h2>
          <div className={styles.valuesList}>
            <div className={styles.valueItem}>
              <span className={styles.valueName}>Innovation:</span> Pioneering technologies that enhance safety and
              convenience.
            </div>
            <div className={styles.valueItem}>
              <span className={styles.valueName}>Collaboration:</span> Building strong partnerships to drive meaningful
              change.
            </div>
            <div className={styles.valueItem}>
              <span className={styles.valueName}>User-Centricity:</span> Designing intuitive solutions tailored to user
              needs.
            </div>
            <div className={styles.valueItem}>
              <span className={styles.valueName}>Sustainability:</span> Creating eco-friendly technologies for a greener
              future.
            </div>
          </div>
        </div>
      </section>
    </div>
    </section>
  )
}

export default VisionMission